module.exports = __webpack_public_path__ + "static/media/location5.601668c4.webp";